import API_BACK from "../lib/axiosBack";
// import API from "../lib/axios";
import { logoutCompletely } from "../utils/logoutCompletely";

export const exportData = async (
  endpoint: string,
  filters: Record<string, any>,
  filenamePrefix: string
) => {
  const token = localStorage.getItem("accessToken");
  if (!token) {
    console.warn("⚠️ No access token, logging out");
    logoutCompletely();
    return;
  }

  try {
    const response = await API_BACK.get(endpoint, {
      // const response = await API.get(endpoint, {
      params: filters,
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "text/csv",
      },
      responseType: "blob",
    });

    const blob = response.data as Blob;
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    const fileName = `${filenamePrefix}_export_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/:/g, "-")}.csv`;
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error: any) {
    const status = error?.response?.status;
    if (status === 401) {
      console.warn("🔒 Unauthorized (401), logging out");
      logoutCompletely();
    } else if (status === 400) {
      console.error("📛 Invalid request parameters (400)");
    } else if (status === 500) {
      console.error("💥 Internal server error (500)");
    } else {
      console.error("❌ Unknown error during export:", error);
    }

    throw error;
  }
};
